import { autoAuthConstants } from '../constants/autoAuthConstants';
import packageJson from '../../../package.json';
import { logoutUser } from './login.action';
import { isMobileApp, log } from '../../common/common';
import { json } from 'react-router-dom';
import axios from 'axios';
import axiosOpenInstance from '../helper/axiosOpenInstance';

const apiVersion = packageJson.version;

const url = process.env.REACT_APP_API_URL;

export const validateAutoAuthToken = (token, callback) => {
  // console.log("my token at validateAutoAuthToken===>", token, url + 'autologin/validate');
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: url + 'autologin/validate',
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      }
    })
      .then((response) => {
        // console.log('Validate', response.data);
        if (response.data) {
          callback(response.data);
          dispatch({
            type: autoAuthConstants.TOKEN_VALIDATE_SUCCESS
          });
        }
      })
      .catch((error) => {
        // console.log("inside error block", error);
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }

        log('Error', error);
        callback('error');
        dispatch({
          type: autoAuthConstants.TOKEN_VALIDATE_FALIURE
        });
      });
  };
};
export const checkDuplicateEmail = (token, email, callback) => {
  let formdata = new FormData();
  formdata.append('email', email);
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: url + 'autologin/check_email_condition',
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      },
      data: formdata
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }

        log('Error', error);
        callback('error');
      });
  };
};

export const checkDuplicateMobile = (token, phone_no, callback) => {
  let formdata = new FormData();
  formdata.append('phone_no', phone_no);
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: url + 'autologin/check_mobile_condition',
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      },
      data: formdata
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }

        log('Error', error);
        callback('error');
      });
  };
};

export const autoAuthSignUp = (token, formData, callback) => {
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: url + 'autologin/signup',
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      },
      data: formData
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch({
            type: autoAuthConstants.AUTOAUTH_SIGNUP_SUCCESS
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }
        console.log('Ah');
        log('Error', error);
        callback('error');
        dispatch({
          type: autoAuthConstants.AUTOAUTH_SIGNUP_FALIURE
        });
      });
  };
};

export const checkDoctorCertificate = (token, payload, callback) => {
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: `${url}openapi/authenticatecertificate`,
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      },
      data: payload
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }
        console.log('Ah');
        log('Error', error);
        callback('error');
      });
  };
};

export const getUserCertificate = (token, payload, callback) => {
  return (dispatch) => {
    axiosOpenInstance({
      method: 'POST',
      url: `${url}autologin/get_user_certificate`,
      headers: {
        Authorization: token,
        version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
      },
      data: payload
    })
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            dispatch(logoutUser());
          }
        }
        console.log('Ah');
        log('Error', error);
        callback('error');
      });
  };
};
